<script lang="ts">
  import { getEmblaContext } from "./context.js"

  const { index } = $props<{ index: number }>()

  const emblaCtx = getEmblaContext("<Carousel.Dot/>")

  const selected = $derived(emblaCtx.selectedIndex === index)
</script>

<button
  class="w-1.5 h-1.5 rounded-full transition-all duration-300 {selected
    ? 'bg-white w-3'
    : 'bg-white/50'}"
  onclick={() => emblaCtx.scrollTo(index)}
  aria-label="Go to slide {index + 1}"
></button>
